<template>
  <FiltersTooltip :is-offer="true" v-if="code && icon" :icon="icon" :code="code">
    <template #header>
      <img :alt="alt_text" class="icon__custom icon__custom__plain" style="width: 24px;" :style="style_for_offer_icon" :src="getImgURL(src)"/>
    </template>
  </FiltersTooltip>
  <v-tooltip v-else-if="icon && text">
    <template #activator="{ props }">
      <img :alt="alt_text" v-bind="props" class="icon__custom icon__custom__plain" style="width: 24px;" :src="getImgURL(src)"/>
    </template>
    <div>
      {{ text }}
    </div>
  </v-tooltip>
  <!-- <Teleport :to=""> -->
  <img :alt="alt_text" v-else class="icon__custom icon__custom__plain" style="width: 24px;" :src="getImgURL(src)"/>
  <!-- </Teleport> -->
</template>
<script>
export default {
  name: 'IconWithTooltip'
}
</script>
<script setup>
import FiltersTooltip from "../agregator_filters/FiltersTooltip.vue";
import getImgURL from '../../composables/getImgUrl.js'

const pr = defineProps(['code', 'icon', 'text', 'style_for_offer_icon']);
const src = `oknamedia_icons/${pr.icon}.svg`;
const alt_text = "Иконка примененного фильтра";
</script>
